// extracted by mini-css-extract-plugin
export default {"contactPage":"ContactPage_contactPage__r636m"};